import {
  defaultRankTransformer,
  defaultSuitTransformer,
} from "../constants/cardTransformers"
import {
  ranksAndSuits,
} from "../constants/initialData"

export const reverseTransformer = (transformer) => {
  const reversedObject = {};
  for (const field in transformer) {
    reversedObject[transformer[field]] = field;
  }
  return reversedObject;
};

export const transformCardToService = (card) => {
  return {
    rank: defaultRankTransformer[card.rank.id],
    suit: defaultSuitTransformer[card.suit.id],
  };
};

export const transformCardFromService = (card) => {
  return {
    rank: getRankFromId(reverseTransformer(defaultRankTransformer)[card.rank]),
    suit: getSuitFromId(reverseTransformer(defaultSuitTransformer)[card.suit]),
  };
};

export const getSuitFromId = (id) => {
  return ranksAndSuits.suits.find(suit => suit.id === id);
};

export const getRankFromId = (id) => {
  return ranksAndSuits.ranks.find(rank => rank.id === id);
};

export const getPlayerById = (players, id) => {
  return players.find(player => player.player === id);
};


export const getPlayerFromId = (players, id) => {
  return players.find(suit => suit.id === id).playerName;
};

export const getActiveOption = (options) => {
  return options && options.find(option => option.active)
};

export const filterExistOptions = (options) => {
  return options && options.filter(option => option)
};

export const getTableCards = (table) => {
  const cards = [];
  let i = 0;
  for (i; i < table.flop.length; ++i) {
    cards.push(transformCardToService(table.flop[i]));
  }
  cards.push(transformCardToService(table.turn));
  cards.push(transformCardToService(table.river));

  return {
    cards
  }
};

export const getTableCardsCount = (table) => {
  let cardsCount = 0;
  let i = 0;
  for (i; i < (table.flop && table.flop.length); ++i) {
    if (table.flop[i] !== undefined) {
      cardsCount++
    }
  }
  if (table.turn !== undefined) {
    cardsCount++
  }
  if (table.river !== undefined) {
    cardsCount++
  }

  return cardsCount
};

export const getPOCTableCards = (table) => {
  const cards = [];
  let i = 0;
  for (i; i < (table.flop && table.flop.length); ++i) {
    if (table.flop[i]) {
      const transformedFlop = transformCardToService(table.flop[i]);
      cards.push(transformedFlop.rank + transformedFlop.suit);
    }
  }
  const transformedTurn = table.turn && transformCardToService(table.turn);
  const transformedRiver = table.river && transformCardToService(table.river);
  if (transformedTurn) {
    cards.push(transformedTurn.rank + transformedTurn.suit);
  }

  if (transformedRiver) {
    cards.push(transformedRiver.rank + transformedRiver.suit);
  }

  return cards;
};

export const isObjectsSame = (object1, object2) => {
  return JSON.stringify(object1) === JSON.stringify(object2);
};

export const getNearestEmptyCard = (players, table, currentActiveField) => {
  let cardIndex;
  if (currentActiveField.type === false) {
    currentActiveField.type = 'player';
    currentActiveField.id = 0;
    currentActiveField.card.type = 'player';
    currentActiveField.card.id = 0;
  }
  let i = currentActiveField.id;
  switch (currentActiveField.type) {
    case 'player':
      for (i; i < players.length; ++i) {
        cardIndex = players[i].hand.findIndex(card => card === false);
        if (cardIndex !== -1) {
          return {
            type: 'player',
            id: i,
            card: {
              type: 'player',
              id: cardIndex,
            }
          };
        }
      }
      i = 0;
      for (i; i < players.length; ++i) {
        cardIndex = players[i].hand.findIndex(card => card === false);
        if (cardIndex !== -1) {
          return {
            type: 'player',
            id: i,
            card: {
              type: 'player',
              id: cardIndex,
            }
          };
        }
      }
      for (const field in table) {
        if (table[field].length) {
          cardIndex = table[field].findIndex(card => card === false);
          if (cardIndex !== -1) {
            return {
              type: 'table',
              id: 0,
              card: {
                type: field,
                id: cardIndex,
              }
            };
          }
        } else {
          cardIndex = table[field] === false;
          if (cardIndex) {
            return {
              type: 'table',
              id: 0,
              card: {
                type: field,
                id: 0,
              }
            };
          }
        }
      }
      break;
    case 'table':
      for (const field in table) {
        if (table[field].length) {
          cardIndex = table[field].findIndex(card => card === false);
          if (cardIndex !== -1) {
            return {
              type: 'table',
              id: 0,
              card: {
                type: field,
                id: cardIndex,
              }
            };
          }
        } else {
          cardIndex = table[field] === false;
          if (cardIndex) {
            return {
              type: 'table',
              id: 0,
              card: {
                type: field,
                id: 0,
              }
            };
          }
        }
      }
      for (i; i < players.length; ++i) {
        cardIndex = players[i].hand.findIndex(card => card === false);
        if (cardIndex !== -1) {
          return {
            type: 'player',
            id: i,
            card: {
              type: 'player',
              id: cardIndex,
            }
          };
        }
      }
      i = 0;
      for (i; i < players.length; ++i) {
        cardIndex = players[i].hand.findIndex(card => card === false);
        if (cardIndex !== -1) {
          return {
            type: 'player',
            id: i,
            card: {
              type: 'player',
              id: cardIndex,
            }
          };
        }
      }
      break;
    default:
      return {
        type: 'player',
        id: 0,
        card: {
          type: 'player',
          id: 0,
        }
      };
  }

  switch (currentActiveField.type) {
    case 'player':
      return {
        type: 'player',
        id: 0,
        card: {
          type: 'player',
          id: 0,
        }
      };
    case 'table':
      return {
        type: 'table',
        id: 0,
        card: {
          type: 'flop',
          id: 0,
        }
      };
    default:
      return {
        type: 'player',
        id: 0,
        card: {
          type: 'player',
          id: 0,
        }
      };
  }
};

export const getNearestTableShirt = (table) => {
  let shirtIndex;

  for (const field in table) {
    if (table[field].length) {
      shirtIndex = table[field].findIndex(card => card === false);
      if (shirtIndex !== -1) {
        return {
          type: 'table',
          id: 0,
          card: {
            type: field,
            id: shirtIndex,
          }
        };
      }
    } else {
      shirtIndex = table[field] === false;
      if (shirtIndex) {
        return {
          type: 'table',
          id: 0,
          card: {
            type: field,
            id: 0,
          }
        };
      }
    }
  }
  return false;
};

export const getNextEmptyCard = (players, table, currentActiveField) => {
  let cardIndex;
  switch (currentActiveField.type) {
    case 'player':
      let i = currentActiveField.id;
      for (i; i < players.length; ++i) {
        cardIndex = players[i].hand.findIndex(card => card === false);
        if (cardIndex !== -1) {
          return {
            type: 'player',
            id: i,
            card: {
              type: 'player',
              id: cardIndex,
            }
          };
        }
      }
      break;
    case 'table':
      for (const field in table) {
        switch (currentActiveField.card.type) {
          case 'flop':
            cardIndex = table[field].findIndex((card, index) => {
              if (index <= currentActiveField.card.id) {
                return false
              }
              return card === false
            });
            if (cardIndex !== -1) {
              return {
                type: 'table',
                id: 0,
                card: {
                  type: field,
                  id: cardIndex,
                }
              };
            } else {
              cardIndex = table['turn'] === false;
              if (cardIndex) {
                return {
                  type: 'table',
                  id: 0,
                  card: {
                    type: 'turn',
                    id: 0,
                  }
                };
              } else {
                cardIndex = table['river'] === false;
                if (cardIndex) {
                  return {
                    type: 'table',
                    id: 0,
                    card: {
                      type: 'river',
                      id: 0,
                    }
                  };
                } else {
                  return getNearestEmptyCard(players, table, currentActiveField)
                }
              }
            }
          case 'turn':
            cardIndex = table['turn'] === false;
            if (cardIndex) {
              return {
                type: 'table',
                id: 0,
                card: {
                  type: 'turn',
                  id: 0,
                }
              };
            } else {
              cardIndex = table['river'] === false;
              if (cardIndex) {
                return {
                  type: 'table',
                  id: 0,
                  card: {
                    type: 'river',
                    id: 0,
                  }
                };
              } else {
                return getNearestEmptyCard(players, table, currentActiveField)
              }
            }
          case 'river':
            cardIndex = table['river'] === false;
            if (cardIndex) {
              return {
                type: 'table',
                id: 1,
                card: {
                  type: 'river',
                  id: 0,
                }
              };
            } else {
              return getNearestEmptyCard(players, table, currentActiveField)
            }
          default:
            return false
        }
      }
      break;
    default:
      return false
  }

  return false;
};

export const whichHandWinsValidation = (players, table) => {
  let isEverythingFilled = true;
  let i = 0;
  for (i; i < players.length; ++i) {
    isEverythingFilled = players[i].hand.find(card => !card);
    if (isEverythingFilled === false) {
      return isEverythingFilled;
    }
  }

  return isTableFilled(table);
};

export const isTableFilled = (table) => {
  let isEverythingFilled = true;

  for (const field in table) {
    if (table[field].length) {
      isEverythingFilled = table[field].find(card => card === false);
      if (isEverythingFilled === false) {
        return false;
      }
    } else {
      isEverythingFilled = !!table[field];
      if (!isEverythingFilled) {
        return isEverythingFilled;
      }
    }
  }
  return true;
};

export const tableFlopValidation = (flop) => {
  const filledCardsCount = flop && filterExistOptions(flop).length;
  return filledCardsCount === 0 || filledCardsCount === 3;
};

export const getCardsCount = (player, cardsCount) => {
  player.hand.map((card) => {
    if (card) {
      cardsCount++
    }
    return card
  });

  return cardsCount
};

export const isPlayersCardsCountEqual = (players) => {
  let cardsCount = 0;
  let necessaryCardsCount = 0;
  let i = 0;
  for (i; i < players.length; ++i) {
    cardsCount = getCardsCount(players[i], cardsCount);
    if (i === 0) {
      necessaryCardsCount = cardsCount;
    }
    if (cardsCount !== necessaryCardsCount) {
      return false
    }
    cardsCount = 0;
  }

  return true;
};

export const isReadyToCalculateOdds = (players, table, rules) => {
  let isEverythingFilled = true;

  if (players) {
    let i = 0;
    for (i; i < players.length; ++i) {
      const hand = players[i].hand;
      let emptyField = false;
      let j = 0;
      let cardsCount = 0;
      for (j; j < hand.length; ++j) {
        if (hand[j]) {
          if (emptyField) {
            return false;
          }
          cardsCount++;
        } else {
          emptyField = true;
          if (cardsCount < rules.minNumberOfFilledCardsInHandForCosting) {
            return false
          }
        }
      }
      if (cardsCount < rules.minNumberOfFilledCardsInHandForCosting) {
        return false
      }
    }
  }

  let tableCardsCount = 0;
  let emptyField = false;
  for (const field in table) {
    if (table[field].length) {
      let i = 0;
      for (i; i < table[field].length; ++i) {
        if (table[field][i]) {
          if (emptyField) {
            return false
          }
          tableCardsCount++;
        } else {
          emptyField = true;
          if (tableCardsCount < rules.minNumberOfFilledCardsOnBoardForCosting) {
            return false
          }
        }
      }
    } else {
      if (table[field]) {
        if (emptyField) {
          return false;
        }
        tableCardsCount++;
      }
    }
  }
  if (tableCardsCount < rules.minNumberOfFilledCardsOnBoardForCosting) {
    return false
  }
  return isEverythingFilled;
};